import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/e8d9864e0d1c345c04aa52accd571aeb.png"
              alt="Spyder Restoration"
              className="h-20 mb-4 drop-shadow-lg"
            />
            <p className="text-gray-400 mb-4 text-sm">
              Michiana's premier restoration experts. Quality workmanship, honest service, lifetime warranties.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-cyan-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
            <div className="mt-4">
              <span className="inline-block bg-gray-800 text-white px-3 py-1 rounded text-sm font-semibold">BBB A+ Rated</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 uppercase">Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services/roofing" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Roofing
                </Link>
              </li>
              <li>
                <Link to="/services/siding" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Siding
                </Link>
              </li>
              <li>
                <Link to="/services/gutters" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Gutters
                </Link>
              </li>
              <li>
                <Link to="/services/windows" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Windows
                </Link>
              </li>
              <li>
                <Link to="/services/doors" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Doors
                </Link>
              </li>
              <li>
                <Link to="/services/storm-damage" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Storm Damage
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 uppercase">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  About Us
                </Link>
              </li>
              <li>
                <a href="/#quote" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Get Quote
                </a>
              </li>
              <li>
                <Link to="/careers" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Careers
                </Link>
              </li>
              <li>
                <a href="/#quote" className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center gap-2 cursor-pointer">
                  <i className="ri-arrow-right-s-line text-cyan-400"></i>
                  Financing
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 uppercase">Contact Info</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-fill text-cyan-400 text-xl flex-shrink-0"></i>
                <span className="text-gray-400">Elkhart, IN<br />Serving Michiana Area</span>
              </li>
              <li>
                <a href="tel:5743503050" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  <i className="ri-phone-fill text-cyan-400 text-xl"></i>
                  574-350-3050
                </a>
              </li>
              <li>
                <a href="https://wa.me/12693074842" target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer">
                  <i className="ri-whatsapp-fill text-cyan-400 text-xl"></i>
                  269-307-4842
                </a>
              </li>
              <li>
                <a href="mailto:spyderrestorationllcmi@gmail.com" className="flex items-start gap-3 text-gray-400 hover:text-cyan-400 transition-colors cursor-pointer break-all">
                  <i className="ri-mail-fill text-cyan-400 text-xl flex-shrink-0"></i>
                  spyderrestorationllcmi@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              &copy; {currentYear} Spyder Restoration LLC. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <span className="text-gray-400 text-sm">Licensed &amp; Insured</span>
              <span className="text-gray-600">|</span>
              <a href="https://meltgraphicsprint.com/" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 text-sm hover:text-cyan-400 transition-colors cursor-pointer">
                <img 
                  src="https://static.readdy.ai/image/2733261fde4eb6ca5d5b92336d650a8a/c095d581dc1845a3b1c3b759951a8d5b.png" 
                  alt="Melt Graphics" 
                  className="h-6 w-6 object-contain"
                />
                Powered by Melt Graphics
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
